import { SCALE_CHORD_QUALITIES, CHORD_INTERVALS } from '../../../utils/music/constants';
import { ChordQuality } from '../../../types';

export class ChordBuilder {
    /**
     * CHORD BUILDER
     * Constructs raw chord notes based on scale and quality.
     */
    public getChordNotes(scaleNotes: number[], rootScaleIndex: number, quality: ChordQuality, scaleType: string, rootMidi: number): number[] {
        const chordNotes: number[] = [];
        const chordIntervals = CHORD_INTERVALS[quality];

        // DETECT: Standard 7-note scale (Major, Minor, Modes) vs Pentatonic/Exotic
        // Rough check for heptatonic scales
        const isHeptatonic = CHORD_INTERVALS[quality].length >= 3 &&
            ([0, 2, 4, 5, 7, 9, 11].includes(scaleType === 'major' ? 0 : -1) ||
                ['major', 'minor', 'harmonic_minor', 'melodic_minor', 'dorian', 'phrygian', 'lydian', 'mixolydian'].includes(scaleType));

        if (isHeptatonic) {
            // STRICT DIATONIC STACKING
            const indices = [0, 2, 4]; // Triad

            indices.forEach(offset => {
                if (rootScaleIndex + offset < scaleNotes.length) {
                    chordNotes.push(scaleNotes[rootScaleIndex + offset]);
                }
            });
        } else {
            // CHROMATIC SNAP (Fallback for Pentatonics / Blues)
            for (let i = 0; i < Math.min(3, chordIntervals.length); i++) {
                const targetMidi = rootMidi + chordIntervals[i];
                const closestNote = this.findClosestInScale(scaleNotes, targetMidi);
                if (closestNote !== null) {
                    chordNotes.push(closestNote);
                }
            }
        }

        return chordNotes;
    }

    public getChromaticChord(rootMidi: number, quality: ChordQuality): number[] {
        const intervals = CHORD_INTERVALS[quality] || CHORD_INTERVALS['major'];
        return intervals.map(interval => rootMidi + interval);
    }

    private findClosestInScale(scaleNotes: number[], targetMidi: number): number | null {
        if (scaleNotes.length === 0) return null;

        let closest = scaleNotes[0];
        let minDiff = Math.abs(scaleNotes[0] - targetMidi);

        for (const note of scaleNotes) {
            const diff = Math.abs(note - targetMidi);
            if (diff < minDiff) {
                minDiff = diff;
                closest = note;
            }
        }

        return closest;
    }
}
